<template>
  <div>
    <header class="header change-color">
      <div class="container">
        <div class="row ib-topbar">
          <div class="col-sm-12 d-none d-lg-block">
            <div v-if="login" class="float-right pr-4 d-flex ib-user-sm">
              <div class="mytooltip">
                <div>
                  <div class="ib-user-photo">
                    <img class="img-fluid" :src="user.avatar" alt="logo">>
                  </div>
                  <div class="founder-nav-tag" v-if="user.is_founder_member">
                      <img class="img-fluid" alt="icon" :src="require('@/assets/images/founder.svg')" />
                  </div>
                </div>
                <div class="ib-profile-title text-capitalize">{{user.first_name}}</div>
                <span class="mytext">
                  <div class="d-block">
                  <a href="#0">
                    <div class="ib-flex-between">
                    <div class="position-relative">
                      <div class="ib-user-photo">
                      <img class="img-fluid" :src="user.avatar" alt="logo">
                      </div>
                      <div class="founder-tooltip-tag" v-if="user.is_founder_member">
                        <img class="img-fluid" alt="icon" :src="require('@/assets/images/founder.svg')" />
                      </div>
                    </div>
                    <div class="ib-left-mr">
                      <div class="ib-profile-title">{{user.first_name}}</div>
                    <div class="ib-profile-email">{{user.username}}</div>
                    </div>
                    </div>
                  </a>
                  </div>
                  <hr class="w-100" style="border-top: 2px dotted;">
                  <div class="d-block">
                    <ul>
                      <li>
                        <router-link :to="{ name: 'ViewProfile' }">
                          <img :src="require('@/assets/images/tooltip-profile-icon-2x.png')" alt="icon">My Profile
                          <span class="chevron right"></span>
                        </router-link>
                      </li>
<!--                      <li>-->
<!--                        <router-link :to="{ name: 'ViewWallet' }">-->
<!--                          <img :src="require('@/assets/images/Group 84458.svg')" alt="icon">My Wallet-->
<!--                          <span class="chevron right"></span>-->
<!--                        </router-link>-->
<!--                      </li>-->
                      <li>
                        <router-link :to="{ name: 'UpdatePassword' }">
                          <img :src="require('@/assets/images/tooltip-password-icon-2x.png')" alt="icon">Change Password
                          <span class="chevron right"></span>
                        </router-link>
                      </li>
                      <li>
                        <router-link :to="{ name: 'AbandonedCart' }">
                          <img :src="require('@/assets/images/tooltip-cart-icon-2x.png')" alt="icon">Abandoned Cart
                          <span class="chevron right"></span>
                        </router-link>
                      </li>
                      <li>
                        <router-link :to="{ name: 'Promotions' }">
                          <img :src="require('@/assets/images/tooltip-promotion-icon-2x.png')" alt="icon">Promotions
                          <span class="chevron right"></span>
                        </router-link>
                      </li>
<!--                      <li>-->
<!--                        <router-link :to="{ name: 'Home' }">-->
<!--                          <img :src="require('@/assets/images/tooltip-settings-icon-2x.png')" alt="icon">Settings-->
<!--                          <span class="chevron right"></span>-->
<!--                        </router-link>-->
<!--                      </li>-->
                      <li>
                        <a class="" style="font-size:15px; margin-bottom: 1px;" @click="logout">Signout</a>
                      </li>
                    </ul>
                  </div>
                </span>
              </div>
            </div>
            <div v-else class="float-right pr-3 d-flex">
              <div class="topbar-alignment">
                <span class="topbar-text">Not a User? Please</span>
                <a class="ib-link" @click="showSignupModal" style="margin-right:30px;">Sign Up</a>
              </div>
              <button class="ib-btn-primary ib-btn-hover" @click="showLoginModal" style="margin-bottom: 1px;">Sign In</button>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <section class="wrapper">
          <router-link :to="{ name: 'Home' }" class="brand">
            <img alt="Logo Icon" class="img-fluid ib-main-logo" :src="require('@/assets/images/ib-logo.svg')" />
          </router-link>
          <button class="opened-menu">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div id="side_overlay" class="overlay"></div>
          <nav id="mySidebar" v-if="login" class="navbar wow animate__animated animate__fadeInRight">
            <button class="closed-menu" type="button">
              <img alt="closed" class="closed-icon" :src="require('@/assets/images/closed.svg')" />
            </button>

            <!-- sidebar profile area -->
            <div class="w-100 d-lg-none">
              <div v-if="login" class="d-flex ib-user-sm">
                <div class="mytooltip in-sidebar-tooltip ib-cursor-pointer" @click="inTogggleUser()">
                  <div>
                    <div class="ib-user-photo">
                      <img class="img-fluid" :src="user.avatar" alt="logo">>
                    </div>
                    <div class="founder-nav-tag" v-if="user.is_founder_member">
                        <img class="img-fluid" alt="icon" :src="require('@/assets/images/founder.svg')" />
                    </div>
                  </div>
                  <div class="ib-profile-title text-capitalize">{{user.first_name}}</div>

                  <span class="mytext in-sidebar-mytext" id="toggleDiv">
                    <div class="d-block">
                    <a href="#0">
                      <div class="ib-flex-between">
                      <div class="position-relative">
                        <div class="ib-user-photo">
                        <img class="img-fluid" :src="user.avatar" alt="logo">
                        </div>
                        <div class="founder-tooltip-tag" v-if="user.is_founder_member">
                          <img class="img-fluid" alt="icon" :src="require('@/assets/images/founder.svg')" />
                        </div>
                      </div>
                      <div class="ib-left-mr">
                        <div class="ib-profile-title">{{user.first_name}}</div>
                      <div class="ib-profile-email">{{user.username}}</div>
                      </div>
                      </div>
                    </a>
                    </div>
                    <hr class="w-100" style="border-top: 2px dotted;">
                    <div class="d-block">
                      <ul>
                        <li @click="CloseNav()">
                          <router-link :to="{ name: 'ViewProfile' }">
                            <img :src="require('@/assets/images/tooltip-profile-icon-2x.png')" alt="icon">My Profile
                            <span class="chevron right"></span>
                          </router-link>
                        </li>
                        <li @click="CloseNav()">
                          <router-link :to="{ name: 'UpdatePassword' }">
                            <img :src="require('@/assets/images/tooltip-password-icon-2x.png')" alt="icon">Change Password
                            <span class="chevron right"></span>
                          </router-link>
                        </li>
                        <li @click="CloseNav()">
                          <router-link :to="{ name: 'AbandonedCart' }">
                            <img :src="require('@/assets/images/tooltip-cart-icon-2x.png')" alt="icon">Abandoned Cart
                            <span class="chevron right"></span>
                          </router-link>
                        </li>
                        <li @click="CloseNav()">
                          <router-link :to="{ name: 'Promotions' }">
                            <img :src="require('@/assets/images/tooltip-promotion-icon-2x.png')" alt="icon">Promotions
                            <span class="chevron right"></span>
                          </router-link>
                        </li>
  <!--                      <li @click="CloseNav()">-->
  <!--                        <router-link :to="{ name: 'Home' }">-->
  <!--                          <img :src="require('@/assets/images/tooltip-settings-icon-2x.png')" alt="icon">Settings-->
  <!--                          <span class="chevron right"></span>-->
  <!--                        </router-link>-->
  <!--                      </li>-->
                        <li>
                          <a class="" style="font-size:15px; margin-bottom: 1px;" @click="logout">Signout</a>
                        </li>
                      </ul>
                    </div>
                  </span>
                </div>
              </div>
              <div v-else class="d-none">
              </div>
            </div>

            <!-- sidebar profile area -->
            <ul class="menu in-sidemenu-fixed" style="margin-bottom:0px;">
              <li class="menu-item" @click="CloseNav()">
                <router-link :to="{ name: 'Home' }">
                  <span class="d-lg-none"  content="Home" v-tippy>Home</span>
                  <img class="d-none d-lg-inline-block img-fluid in-bottom-5" content="Home" v-tippy :src="require('@/assets/images/new-home-icon.svg')" alt="icon">
                </router-link>
              </li>
              <li class="menu-item" @click="CloseNav()">
                <router-link :to="{ name: 'Products' }">Products</router-link>
              </li>
              <li class="menu-item menu-item-has-children">
                <a data-toggle="sub-menu" href="#">
                  Policies
                  <img class="img-fluid in-arrow-wh" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
                </a>
                <ul class="sub-menu">
                  <li class="menu-item" @click="CloseNav()">
                    <router-link :to="{ name: 'Policies' }">
                      <img :src="require('@/assets/images/submenu_policies_listings.svg')" alt="icon">
                      Policy Listing
                      <span class="chevron right custom-right"></span>
                    </router-link>
                  </li>
                  <li class="menu-item" @click="CloseNav()">
                    <router-link :to="{name: 'PolicyServicing'}">
                    <img :src="require('@/assets/images/submenu_policy_servicing.svg')" alt="icon">
                      Policy Servicing
                      <span class="chevron right custom-right"></span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="menu-item" @click="CloseNav()">
                <router-link :to="{ name: 'Claims' }" class="jbl-flex-icon">Claims</router-link>
              </li>
              <li class="menu-item menu-item-has-children">
                <a data-toggle="sub-menu" href="#">
                  Documents
                  <img class="img-fluid in-arrow-wh" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
                </a>
                <ul class="sub-menu">
                  <li class="menu-item" @click="CloseNav()">
                    <router-link :to="{ name : 'PolicyDocument' }">
                      <img :src="require('@/assets/images/submenu_policy_documnent.svg')" alt="icon">
                      Policy Document
                      <span class="chevron right custom-right"></span>
                    </router-link>
                  </li>
                  <li class="menu-item" @click="CloseNav()">
                    <router-link :to="{ name : 'ClaimDocument' }">
                      <img :src="require('@/assets/images/submenu_claim_document.svg')" alt="icon">
                      Claim Document
                      <span class="chevron right custom-right"></span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="menu-item menu-item-has-children">
                <a data-toggle="sub-menu" href="#">
                  Account
                  <img class="img-fluid in-arrow-wh" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
                </a>
                <ul class="sub-menu">
                  <li class="menu-item" @click="CloseNav()">
                    <router-link :to="{ name : 'Renewal' }">
                      <img :src="require('@/assets/images/submenu_renewal.svg')" alt="icon">
                      Renewals
                      <span class="chevron right custom-right"></span>
                    </router-link>
                  </li>
                  <li class="menu-item" @click="CloseNav()">
                    <router-link :to="{ name : 'ComplaintFeedback' }">
                      <img :src="require('@/assets/images/submenu_complaints&_feedback.svg')" alt="icon">
                      Complaints&nbsp;&amp;&nbsp;Feedback
                      <span class="chevron right custom-right"></span>
                    </router-link>
                  </li>
                  <li class="menu-item" @click="CloseNav()">
                    <router-link :to="{ name : 'RecentSearch' }">
                      <img :src="require('@/assets/images/submenu_search_history.svg')" alt="icon">
                      Recent Searches
                      <span class="chevron right custom-right"></span>
                    </router-link>
                  </li>
                  <li class="menu-item" @click="CloseNav()">
                    <router-link :to="{ name : 'Wishlist' }">
                      <img :src="require('@/assets/images/submenu_wishlist.svg')" alt="icon">
                      Wishlist
                      <span class="chevron right custom-right"></span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="menu-item" @click="CloseNav()">
                <router-link :to="{ name : 'Notifications' }">
                  <span class="d-lg-none">Notifications</span>
                  <div class="position-relative d-none d-lg-inline-block" content="Notifications" v-tippy>
                    <img class="d-none d-lg-inline-block img-fluid in-bottom-5 in-w-18" :src="require('@/assets/images/new-bell-icon.svg')" alt="icon">
                  <span class="counter" v-if="notificationCount > 0">{{ notificationCount }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </nav>

          <nav id="mySidebar" v-else class="navbar wow animate__animated animate__fadeInRight">
            <button class="closed-menu" type="button">
              <img alt="closed" class="closed-icon" :src="require('@/assets/images/closed.svg')" />
            </button>
            <ul class="menu menu-position-right" style="margin-bottom:0;">
              <li class="menu-item" @click="CloseNav()">
                <router-link :to="{ name: 'Home' }">
                  <span class="d-lg-none">Home</span>
                  <img class="d-none d-lg-inline-block img-fluid in-bottom-5" :src="require('@/assets/images/new-home-icon.svg')" alt="icon">
                  </router-link>
              </li>
              <li class="menu-item" @click="CloseNav()">
                <router-link :to="{ name: 'Products' }">Products</router-link>
              </li>
              <li class="menu-item" @click="CloseNav()">
                <router-link :to="{ name:'AboutUs' }">About Us</router-link>
              </li>
              <li class="menu-item" @click="CloseNav()">
                <router-link :to="{ name:'ContactUs' }">Contact Us</router-link>
              </li>
              <li class="menu-item" @click="CloseNav()">
                <router-link :to="{ name: 'Promotions' }">Promotions</router-link>
              </li>
              <li class="menu-item" @click="CloseNav()">
                <div class="d-flex d-lg-none p-3" style="padding-left: 30px !important;">
                  <div class="w-50"><a class="sm-auth" @click="showLoginModal">Sign In</a><span class="float-right pr-3 mr-2">&#47;</span></div>
                  <div class="w-50"><a class="sm-auth" @click="showSignupModal">Sign Up</a></div>
                </div>
              </li>
            </ul>
          </nav>
        </section>
      </div>
    </header>

    <!--Login Modal-->
    <div id="LoginModal" class="modal" role="dialog" style="backdrop-filter: contrast(0.5);">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content ib-login-modal">
          <div class="modal-header ib-modal-header" style="display:inline-block !important; width:auto !important;">
            <!-- <span class="ib-m-close" style="position: absolute; right: 10px; top: 10px !important; z-index: 9999 !important;" data-dismiss="modal" aria-label="Close" @click="closeLoginModal">
              &times;
            </span> -->
            <span class="ib-m-close" style="position: absolute; right: 10px; top: 10px !important; z-index: 9999 !important; width:1.5rem;">
              <!-- &times; -->
              <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" @click="closeLoginModal"/>
            </span>
          </div>
          <!-- position: relative;bottom: 30px; -->
          <div class="modal-body login-modal-body in-scroll-body" style="min-height: 500px;display: flex;justify-content: center; align-items:center;">
            <signIn/>
          </div>
        </div>
      </div>
    </div>

    <!--Signup Modal-->
    <div id="SignupModal" class="modal" role="dialog" style="backdrop-filter: contrast(0.5);">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content ib-login-modal">
          <div class="modal-header ib-modal-header" style="padding: 0rem 1rem !important;">
            <!-- <span class="ib-m-close" data-dismiss="modal" aria-label="Close" @click="closeSignupModal">
               &times;
            </span> -->
            <span class="ib-m-close" style="width:1.5rem;">
              <!-- &times; -->
              <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" @click="closeSignupModal"/>
            </span>
          </div>
          <div class="modal-body login-modal-body in-scroll-body" style="min-height: 500px;">
            <signUp/>
          </div>
        </div>
      </div>
    </div>

    <!--Promo Modal-->
    <div id="PromoModal" class="modal" role="dialog" style="backdrop-filter: contrast(0.5);">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header ib-modal-header">
            <span class="ib-m-close" data-dismiss="modal" aria-label="Close" @click="closePromoModal">
              <img class="img-fluid ib-x-icon ib-x-icon2" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
            </span>
          </div>
          <div class="modal-body login-modal-body promo-modal-content in-scroll-body" style="min-height: 500px; background: none !important; background-color:white !important; position: relative; bottom: 20px;">
            <div class="in-promo-thanks">Thank you!</div>
            <div class="in-promo-info in-promo-mb40">for Signing Up</div>
            <img class="img-fluid promo-gift-img in-promo-mb40" :src="require('@/assets/images/gift-box-for-modal.svg')" alt="icon" />
            <div class="in-promo-congrates">Congratulations!</div>
            <div class="in-promo-info">You Are now Eligible to Get</div>
            <div class="in-promo-percent">100% free</div>
            <div class="in-promo-discount in-promo-mb40">Accident &amp; Hospitalization<br>Cover</div>
            <div class="in-promo-info">Become Our</div>
            <div class="in-promo-buy">Founder Member Now!</div>
            <div class="in-promo-info">By Getting the</div>
            <div class="in-promo-percent">Free Cover</div>
            <div class="in-promo-info">&amp; also Win</div>
            <div class="in-promo-percent">Additional Founder Member Discount</div>
            <div class="in-promo-discount">On Your Next Policy</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import signIn from '@/components/Auth/SignIn';
  import signUp from '@/components/Auth/SignUp';

  export default {
    data() {
      return {
        activeItem: "home",
        loggedin: false,
        count: 0,
      };
    },
    components: {
      signIn,
      signUp
    },
    name: "NavBar",
    props: ["login", "user", "notificationCount"],
    created() {
      const self = this;
      if(self.$store.getters.isAuthenticated) {
        self.loggedin = true;
      }
      this.$root.$on('closeSignInOpenSignUpModal', () => {
        self.closeLoginModal();
        self.showSignupModal();
      });
      this.$root.$on('closeSignUpOpenSignInModal', () => {
        self.closeSignupModal();
        self.showLoginModal();
      });
      this.$root.$on('openSignInModal', () => {
        self.showLoginModal();
      });
      this.$root.$on('openSignUpModal', () => {
        self.showSignupModal();
      });
      this.$root.$on('showPromoModal', () => {
        self.showPromoModal();
      });
      this.$root.$on('logoutUser', () => {
        self.logout();
      });
      self.count = this.$props.notificationCount;
    },
    mounted() {
      const self = this;
      if(self.$store.getters.getSignupRedirect) {
        self.showPromoModal();
        self.$store.commit('resetSignupRedirect');
      }
    },
    beforeDestroy() {
      this.$root.$off('closeSignInOpenSignUpModal');
      this.$root.$off('closeSignUpOpenSignInModal');
      this.$root.$off('openSignInModal');
      this.$root.$off('openSignUpModal');
      this.$root.$off('showPromoModal');
      this.$root.$off('logoutUser');
    },
    methods: {
      ...mapActions(["LogOut"]),
      async logout() {
        const self = this;
        axios.post('customer/logout',{
          'device_id' : '00000000',
          'platform' : 'web'
        }).then(function (resp) {
          if (resp.data.code == 200) {
          }
        }).catch(function (resp) {
          $toast.error(resp.data.message, {position: 'top-right'})
        });
        await self.LogOut().then((response) => {
          localStorage.setItem("UserToken", '');
          self.$store.commit("resetState");
          self.$root.$emit('updateUser');
          window.location.href = '/';
        }).catch((resp) => {
          $toast.error(resp.data.message, {position: 'top-right'})
        });
        var mySidebar = document.getElementById("mySidebar");
        mySidebar.classList.remove("active");

        var side_overlay = document.getElementById("side_overlay");
        side_overlay.classList.remove("active");
      },
      CloseNav() {
        var mySidebar = document.getElementById("mySidebar");
        mySidebar.classList.remove("active");

        var side_overlay = document.getElementById("side_overlay");
        side_overlay.classList.remove("active");
      },
      showPromoModal() {
        document.getElementById('PromoModal').style.display = 'block';
      },
      closePromoModal() {
        document.getElementById('PromoModal').style.display = 'none';
      },
      showLoginModal() {
        document.getElementById('LoginModal').style.display = 'block';
        document.getElementById('SignupModal').style.display = 'none';
      },
      closeLoginModal() {
        document.getElementById('LoginModal').style.display = 'none';
      },
      showSignupModal() {
        document.getElementById('SignupModal').style.display = 'block';
        document.getElementById('LoginModal').style.display = 'none';
      },
      closeSignupModal() {
        document.getElementById('SignupModal').style.display = 'none';
      },
      inTogggleUser() {
        var x = document.getElementById("toggleDiv");
        if (x.style.display === "none") {
          x.style.display = "block";
        } else {
          x.style.display = "none";
        }
      }
    }
  };
</script>

<style scoped>
  .topbar-alignment {
    position: relative;
    top: 1.5625rem; /* 25px */
  }
  @media(max-width:34.375rem /* 550px */) {
    .header .wrapper a.brand {
      text-align: center;
      position: relative;
      bottom: 4px;
    }
    .header button.opened-menu {
      position: absolute !important;
      left: 1.5rem /* 24px */ !important;
      margin-bottom: 0.5rem; /* 8px */
    }
    .header .wrapper {
      display: flex;
      justify-content: center !important;
    }
  }
  .in-sidebar-tooltip {
    left: 25px !important;
    top: 0px !important;
  }
  .in-sidebar-tooltip .in-sidebar-mytext {
    width: 17rem !important;
    top: 115% !important;
    left: 72% !important;
  }
  @media( min-width: 768px) {
    .in-md-block {
      display:block !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbar/DefaultNavbar.vue